import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {Amenity, ResidentForSelect} from '../../../types/models';
import {AuthenticationService} from '../../../services/authentication.service';
import {AmenitiesService} from '../../../services/amenities.service';
import {Router} from '@angular/router';
import {ResidentService} from '../../../services/resident.service';
import {environment} from 'environments/environment';
import {Http} from '@angular/http';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;
declare var hj: Function;

@Component({
    selector: 'amenities-modal',
    templateUrl: './amenities-modal.component.html',
    styleUrls: ['./amenities-modal.component.scss']
})
export class AmenitiesModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: Amenity = new Amenity();
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    hours = AmenitiesModalComponent.parseTime((new Date()).toISOString());
    buildingSelectIsDisabled = false;
    isEditModeNoSpinner = false;
    timeRangeSelectValues: Array<any> = [];
    fullResidentsObjectArray: Array<any> = [];
    step = 'amenity';
    showCalendarDatePicker = false;
    calendarOptions: any;
    monthsArray: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    arrayOfMonthsLastDays: Array<number> = [
        31,
        new Date().getFullYear() % 4 == 0 ? 29 : 28,
        31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    cardYearsArray: Array<number> = [];
    payment = {
        cardHolderName: '',
        postalCode: '',
        creditCardNumber: '',
        cardMonth: '',
        cardYear: '',
        cvv: '',
        reservationFee: '',
        securityDeposit: ''
    };
    events = [];
    amenityType = '';
    startHour: any;
    endHour: any;
    daySelectedNumber = null;
    timeSlot: any;
    showTimeSelectSpinner = false;
    residentEmail = '';
    residentPhone = '';
    residentOccupancy = '';
    residentOccupancyDisplayName = '';
    termsAndConditions = '';
    dateToSet = '';
    amenityName = '';
    amenityConfirmationMessage = '';
    disclaimerText = '';
    disclaimerHideFromStaffInterface: any;
    disclaimerStatus: any;
    legalAgreementStatus: any;
    arrayForCalendarColoring: Array<any> = [];
    showCalendarSpinner = false;
    note = '';
    isEditMode = false;
    bookingMaxHour = null;
    bookingMinHour = null;
    bookingType = 'booking';
    showCustomRepeatWindow = false;
    ends = 'never';
    repeatOn = [];
    endOn = new Date();
    checkInHour = '';
    checkOutHour = '';
    originalRules = null;
    availablePaymentMethods = [];
    amenityFees = [];
    creditCardToken: any;
    gettingAmenityForEditing = false;
    nextDayEndTimes = [];
    availableUses = [];
    overrideAvailable = false;
    multipleBookingAllowed = false;
    paymentMethodSelectDisabled = false;
    confirmationSpinner = false;
    eventName = '';
    maxNumberOfParticipants = null;
    minTimeForAdvancedBooking = null;
    overrideTimeRangeSelectValues = AmenitiesModalComponent.generateTimeSelectHours('1970-01-01', 5).map(r => r.time);
    rangeOverrideStartHour = '';
    rangeOverrideEndHour = '';
    quoteStep = '';
    acceptOffer = 1;
    answers = [
        {id: '1', answer: 'I already booked my mover', checked: false},
        {id: '2', answer: 'I am going to do the move myself', checked: false},
        {id: '3', answer: 'I know a great mover and I don\'t need your services', checked: false},
        {id: '4', answer: 'I don\'t trust you', checked: false},
        {id: '5', answer: 'Other (please specify)', checked: false}
    ];
    otherReason: '';
    startTimeSelectValues = [];
    endTimeSelectValues = [];

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public amenitiesService: AmenitiesService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private router: Router,
        private residentService: ResidentService,
        private http: Http
    ) {
    }

    ngOnInit() {
        if (this.authService.userIsResident && environment.production) {
            try {
                hj('trigger', 'amenity_booking');
            } catch (e) {
                console.log('Hotjar script not undefined');
            }
        }
        if (!this.amenitiesService.buildings.length || this.authService.userIsResident)
            this.amenitiesService.getBuildings();
        this.amenitiesService.amenitiesListForModal = [];
        this.initData();
        const currentYear = new Date().getFullYear();
        for (let i = currentYear - 10; i < currentYear + 11; i++)
            this.cardYearsArray.push(i);
        this.calendarOptions = {
            editable: true,
            displayEventEnd: true,
            eventLimit: 4,
            timeFormat: 'h:mma',
            displayEventTime: true,
            showNonCurrentDates: false,
            fixedWeekCount: false,
            header: {
                left: '',
                center: 'prev,title,next',
                right: ''
            },
            events: this.events
        };
        this.amenitiesService.selectedItemData = null;
        this.amenitiesService.showDetailedView = false;
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.isEditModeNoSpinner = false;
        if (this.amenitiesService.amenityInAmenityModal && !this.amenitiesService.isPrefilledFromDirectory) {
            this.data = Object.assign({}, this.amenitiesService.amenityInAmenityModal);
            this.data.acknowledgement = true;
            if (typeof this.data.suiteId == 'string') {
                if ((<any>this.data.suiteId).indexOf('-') != -1) {
                    this.data.suiteId = 0;
                    this.data.residentId = 0;
                }
            } else {
                if (this.data.suiteId.toString().indexOf('-') != -1) {
                    this.data.suiteId = 0;
                    this.data.residentId = 0;
                }
            }
            this.step = 'details';
            this.amenityName = '';
            this.amenityType = '';
            this.isEditMode = true;
            this.gettingAmenityForEditing = true;
            const url = `/v1/amenity/${this.amenitiesService.amenityInAmenityModal.amenityId}.json?expand=buildingAmenity,fees`;
            this.api.get('domainAmenities', `${url}`).subscribe(
                (res) => {
                    const amenity = JSON.parse(res._body);
                    this.data.amenity = this.data.amenityId;
                    this.amenityName = amenity.name;
                    this.amenityType = amenity.timeSequenceType;
                    this.originalRules = amenity.rule;
                    this.availableUses = amenity.uses ? amenity.uses : [];
                    this.overrideAvailable = amenity.managementOverride;
                    this.multipleBookingAllowed = amenity.multipleBooking;
                    this.minTimeForAdvancedBooking = amenity.minTimeForAdvancedBooking;
                    if (!this.data.uses && this.availableUses.length)
                        this.data.uses = this.availableUses[0];
                    if (amenity.defaultPaymentMethod)
                        this.data.paymentMethod = amenity.defaultPaymentMethod;
                    if (amenity.fees && this.bookingType != 'event' && !amenity.isEvent) {
                        amenity.fees.forEach((fee) => {
                            if (fee.active) {
                                if (fee.status)
                                    this.paymentMethodSelectDisabled = true;
                                this.amenityFees.push({
                                    id: fee.id,
                                    active: fee.active,
                                    name: fee.name,
                                    status: fee.status,
                                    amount: fee.amount,
                                    required: fee.required,
                                    include: !!fee.required,
                                    refundable: fee.refundable,
                                    pmtAtTime: fee.pmtAtTime,
                                    pmtHourly: fee.pmtHourly
                                });
                            }
                        });
                        this.data.payments.forEach((payment) => {
                            if (payment.paymentType)
                                this.data.paymentMethod = payment.paymentType;
                            this.amenityFees.forEach((fee) => {
                                if (fee.name == payment.name && fee.status != payment.status) {
                                    fee.status = payment.status;
                                    if (fee.status)
                                        this.paymentMethodSelectDisabled = true;
                                }
                                if (fee.name == payment.name && fee.include != payment.chosen)
                                    fee.include = payment.chosen;
                            });
                        });
                    }
                    if (amenity.paymentAcceptCash) {
                        this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
                    }
                    if (amenity.paymentAcceptCheques) {
                        this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
                    }
                    if (amenity.paymentAcceptCreditCards) {
                        this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
                    }
                    if (amenity.paymentAcceptCertifiedCheque) {
                        this.availablePaymentMethods.push({value: 'certified_cheque', displayName: 'Certified Cheque'});
                    }
                    if (amenity.paymentAcceptMoneyOrder) {
                        this.availablePaymentMethods.push({value: 'money_order', displayName: 'Money Order'});
                    }
                    if (amenity.paymentAcceptBankDraft) {
                        this.availablePaymentMethods.push({value: 'bank_draft', displayName: 'Bank Draft'});
                    }
                    if (amenity.paymentAcceptCustomType) {
                        this.availablePaymentMethods.push({value: 'custom_type', displayName: amenity.paymentCustomTypeName});
                    }
                    if (amenity.legalAgreementStatus && !amenity.legalAgreementHideFromStaffInterface) {
                        this.termsAndConditions = amenity.legalAgreement;
                        this.disclaimerText = amenity.disclaimer;
                        this.disclaimerHideFromStaffInterface = amenity.disclaimerHideFromStaffInterface;

                        this.amenityConfirmationMessage = amenity.confirmationMessage;
                    }
                    if (amenity.disclaimerStatus && !amenity.disclaimerHideFromStaffInterface)
                        this.disclaimerText = amenity.disclaimer;
                    if (this.amenityType == 'hourly') {
                        this.bookingMaxHour = amenity.rule.bookingMaxHour;
                        this.bookingMinHour = amenity.rule.bookingMinHour;
                    }
                    this.daySelectedNumber = new Date(this.data.dateFrom).getDay();
                    const day = moment.utc(this.data.dateFrom);
                    const endDay = moment.utc(this.data.dateTo);
                    this.data.day = day.format('DD.MM.YYYY');
                    if (this.amenityType == 'daily') {
                        this.data.endDay = endDay.format('DD.MM.YYYY');
                        this.checkInHour = amenity.rule.checkInTime;
                        this.checkOutHour = amenity.rule.checkOutTime;
                    }
                    if (this.amenityType == 'hourly' || this.amenityType == 'range') {
                        this.getOvernightEndHours();
                        const startTime = this.getTimeInZeroTimezone(this.data.dateFrom);
                        const endTime = this.getTimeInZeroTimezone(this.data.dateTo);
                        if (this.amenityType == 'hourly') {
                            this.startHour = moment(startTime).format('LT');
                            this.endHour = moment(endTime).format('LT');
                            this.data.endDay = endDay.format('DD.MM.YYYY');
                            this.dateToSet = 'day';
                        }
                        if (this.amenityType == 'range') {
                            const leftPart = moment(startTime).format('LT');
                            const rightPart = moment(endTime).format('LT');
                            this.timeSlot = leftPart + ' - ' + rightPart;
                        }
                        const date = day.format('YYYY-MM-DD');
                        let startDateForSending = moment(date).format('YYYY-MM-DDT00:00');
                        let endDateForSending = moment(date).format('YYYY-MM-DDT23:59');
                        this.getTimeSelectValues(startDateForSending, endDateForSending, this.dateToSet);
                        if (this.amenityType == 'hourly') {
                            const timeString = this.getTwentyFourHourTime(this.startHour);
                            startDateForSending = date + 'T' + timeString;
                            const endDate = endDay.format('YYYY-MM-DD');
                            endDateForSending = endDate + 'T' + '23:59';
                            this.getTimeSelectValues(startDateForSending, endDateForSending, 'endDay');
                        }
                    }
                    if (amenity.isEvent) {
                        this.amenityType = 'eventBooking';
                    }
                    this.gettingAmenityForEditing = false;
                },
                (error) => this.api.errorHandler(error, 'Failed get Amenity For Editing')
            );
            this.isEditModeNoSpinner = true;
            if (this.data.suiteId)
                this.suites = [{id: this.data.suiteId, name: this.data.suiteNumber}];
            else
                this.suites = [{id: 0, name: 'Other'}];
            if (this.data.residentId)
                this.residents = [new ResidentForSelect(this.data.residentId, this.data.residentFullName)];
            else
                this.residents = [new ResidentForSelect(0, 'Other')];
            this.getSuites(this.data.buildingId, this.data.suiteId);
        } else if (this.amenitiesService.amenityInAmenityModal && this.amenitiesService.isPrefilledFromDirectory) {
            this.data = Object.assign({}, this.amenitiesService.amenityInAmenityModal);
            this.amenitiesService.getAmenitiesListByBuilding(this.data.buildingId);
            this.isEditModeNoSpinner = true;
            this.getSuites(this.data.buildingId, this.data.suiteId);
            this.residentEmail = this.data.residentEmail;
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
                this.amenitiesService.buildingsForUpdate.forEach((building) => {
                    if (building.id == b) {
                        this.data.buildingName = building.name;
                        this.data.buildingTimezone = building.timezone;
                    }
                });
                this.amenitiesService.getAmenitiesListByBuilding(b);
                this.getSuites(this.data.buildingId);
            } else if (this.amenitiesService.buildings.length > 1) {
                this.data.buildingId = this.amenitiesService.buildings[0].id;
                this.amenitiesService.buildingsForUpdate.forEach((building) => {
                    if (building.id == this.amenitiesService.buildings[0].id) {
                        this.data.buildingName = building.name;
                        this.data.buildingTimezone = building.timezone;
                    }
                });
                this.amenitiesService.getAmenitiesListByBuilding(this.data.buildingId);
                this.getSuites(this.data.buildingId);
            }

            if (this.amenitiesService.buildings.length === 1) {
                this.data.buildingId = this.amenitiesService.buildings[0].id;
                this.amenitiesService.buildingsForUpdate.forEach((building) => {
                    if (building.id == this.amenitiesService.buildings[0].id) {
                        this.data.buildingName = building.name;
                        this.data.buildingTimezone = building.timezone;
                    }
                });
                this.amenitiesService.getAmenitiesListByBuilding(this.data.buildingId);
                this.getSuites(this.data.buildingId);
            }
            if (this.amenitiesService.prefilledDateFromCaledar) {
                this.data.day = this.amenitiesService.prefilledDateFromCaledar;
                this.daySelectedNumber = new Date(this.data.day.split('.')[2] + '/' + this.data.day.split('.')[1] + '/' + this.data.day.split('.')[0]).getDay();
            }
        }
    }

    hideModal() {
        if ((this.form.dirty && this.form.touched) ||
            (!this.isEditMode && (this.data.amenity || this.data.suiteId ||
                this.data.residentId || this.data.day || this.note || this.data.emailNotification))) {
            swal(ConstantsService.getSwalConfig('Exit without saving?', 'If you close the dialog, the data you have entered will be lost'),
                () => {
                    this.amenitiesService.isAmenityModalShow = false;
                    this.amenitiesService.amenityInAmenityModal = null;
                    this.amenitiesService.isPrefilledFromDirectory = false;
                    this.amenitiesService.prefilledDateFromCaledar = '';
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.amenitiesService.isAmenityModalShow = false;
            this.amenitiesService.amenityInAmenityModal = null;
            this.amenitiesService.isPrefilledFromDirectory = false;
            this.amenitiesService.prefilledDateFromCaledar = '';
            this.urlService.modalClosed.emit();
        }
    }

    confirmBooking() {
        if (this.data.paymentMethod == 'credit_card' && !this.creditCardToken && !this.data.isPayByLink && this.amenityFees.length > 0 && this.includedFieldsExist()) {
            toastr.warning('Credit Card details must be entered and applied.');
            return;
        }

        this.disabledSubmit = true;
        const dateForSending = new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0]));
        const endDateForSending = new Date(parseInt(this.data.endDay.split('.')[2]), parseInt(this.data.endDay.split('.')[1]) - 1, parseInt(this.data.endDay.split('.')[0]));
        let dateFrom;
        let dateTo;
        if (this.amenityType == 'daily') {
            dateFrom = this.convertDayBookingStartEnd(dateForSending, this.checkInHour);
            dateTo = this.convertDayBookingStartEnd(endDateForSending, this.checkOutHour);
        } else if (this.amenityType == 'hourly') {
            dateFrom = this.startHour.datetime;
            dateTo = this.endHour.datetime;
        } else if (this.amenityType == 'range') {
            if (!this.data.managementOverride) {
                dateFrom = this.timeSlot.datetime;
                dateTo = this.timeSlot.datetimeTo;
            } else {
                const endRangeDay = this.timeSlot.split('- ')[1] == '12:00 AM' ?
                    new Date(new Date(dateForSending).setDate(dateForSending.getDate() + 1)) : dateForSending;
                dateFrom = this.setDateAndTime(dateForSending, this.timeSlot.split(' -')[0]);
                dateTo = this.setDateAndTime(endRangeDay, this.timeSlot.split('- ')[1]);
            }
        } else if (this.amenityType == 'eventBooking') {
            dateFrom = this.data.day;
            dateTo = this.data.endDay;
        }
        const data: any = {
            type: this.data.isEvent ? 'event' : 'booking',
            event: this.data.isEvent ? this.data.amenity : undefined,
            building: {
                bdId: (Number(this.residentService.selectedBuilding.buildingId)) ||
                    (this.data.buildingId ? this.data.buildingId : 0),
                name: this.residentService.selectedBuilding.buildingName ||
                    (this.data.buildingId ? this.data.buildingName : null),
                timezone: this.residentService.selectedBuilding.buildingTimezone || (this.data.buildingTimezone ? this.data.buildingTimezone : undefined)
            },
            suite: {
                bdId: (Number(this.residentService.selectedBuilding.suite_id)) ||
                    (this.data.suiteId ? this.data.suiteId :
                        (this.data.buildingId + '-' + this.data.suiteNumber).toLowerCase()),
                suiteNumber: (this.residentService.selectedBuilding.suiteNumber) || (this.data.suiteNumber)
            },
            resident: {
                bdId: (Number(this.residentService.selectedBuilding.residentBdId)) ||
                    (this.data.residentId ? this.data.residentId : 0),
                email: this.residentService.selectedBuilding.userEmail || this.residentEmail,
                fullName: (this.residentService.selectedBuilding.userName) || (this.data.residentFullName),
                isValidEmail: this.data.isValidEmail,
                phoneNumber: this.residentService.selectedBuilding.userPhones ? this.getResidentPrimaryPhone(this.residentService.selectedBuilding.userPhones) : this.residentPhone
            },
            amenity: !this.data.isEvent ? this.data.amenity : undefined,
            dateFrom: dateFrom,
            dateTo: dateTo,
            payments: this.getPaymentsFormatted(),
            uses: this.data.uses,
            managementOverride: this.data.managementOverride ? 1 : 0,
            isPayByLink: this.data.isPayByLink
        };
        if (this.note != '' && (this.note.replace(/&nbsp;/g, '')).replace(/\s/g, '') != '')
            data.notes = [{noteText: this.note}];

        const event = {
            name: this.eventName,
            status: 1,
            amenity: this.data.amenity,
            dateFrom: dateFrom,
            dateTo: dateTo,
            managementOverride: this.data.managementOverride ? 1 : 0,
            maxNumberOfBookings: this.maxNumberOfParticipants
        };

        this.disabledSubmit = true;
        this.confirmationSpinner = true;
        if (this.bookingType != 'event') {
            if (this.data.id) {
                this.api.patch('domainAmenities', `/v1/booking/${this.data.id}.json`, data).subscribe(
                    () => {
                        this.form.reset();
                        this.updateView('Amenity Booking successfully updated');
                        // if(this.showQuoteCheckbox() && this.viewPricingCheckbox)
                        //     this.showQuoteModal();
                    },
                    error => {
                        this.disabledSubmit = false;
                        let errorText = '';
                        const errorBody = JSON.parse(error._body);
                        if (errorBody.errors) {
                            errorBody.errors.forEach(error => errorText += error.description + '. ');
                        } else
                            errorText = errorBody.message;
                        this.api.errorHandler(error, errorText);
                        this.confirmationSpinner = false;
                    }, () => {
                        this.disabledSubmit = false;
                        this.confirmationSpinner = false;
                    }
                );
            } else {
                this.api.post('domainAmenities', '/v1/booking.json', data).subscribe(
                    () => {
                        this.form.reset();
                        this.updateView('Amenity Booking successfully created');
                        // if(this.showQuoteCheckbox() && this.viewPricingCheckbox)
                        //     this.showQuoteModal();
                    },
                    error => {
                        this.disabledSubmit = false;
                        let errorText = '';
                        const errorBody = JSON.parse(error._body);
                        if (errorBody.errors) {
                            errorBody.errors.forEach(error => errorText += error.description + '. ');
                        } else
                            errorText = errorBody.message;
                        this.api.errorHandler(error, errorText);
                        this.confirmationSpinner = false;
                    }, () => {
                        this.disabledSubmit = false;
                        this.confirmationSpinner = false;
                    }
                );
            }
        } else {
            this.api.post('domainAmenities', '/v1/event.json', event).subscribe(
                () => {
                    this.form.reset();
                    this.updateView('Event has been created successfully');
                },
                error => {
                    this.disabledSubmit = false;
                    let errorText = '';
                    const errorBody = JSON.parse(error._body);
                    if (errorBody.errors) {
                        errorBody.errors.forEach(error => errorText += error.description + '. ');
                    } else
                        errorText = errorBody.message;
                    this.api.errorHandler(error, errorText);
                    this.confirmationSpinner = false;
                }, () => {
                    this.disabledSubmit = false;
                    this.confirmationSpinner = false;
                }
            );
        }
    }

    setDateAndTime(dateValue, timeValue): Date {
        const date = new Date(dateValue);
        const timeObj = new Date(`01/01/1970 ${timeValue}`);
        const hours = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000);
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.amenitiesService.isAmenityModalShow = false;
        this.amenitiesService.amenityInAmenityModal = null;
        if (this.router.url !== '/home' && !this.amenitiesService.isPrefilledFromDirectory) {
            this.amenitiesService.getData();
            if (this.amenitiesService.view == 'calendar') {
                if (this.authService.userIsResident)
                    this.amenitiesService.getAmenitiesForCalendarResident();
                else
                    this.amenitiesService.getAmenitiesForCalendar();
            }
        }
    }

    changeBuilding(buildingId: string) {
        this.isEditModeNoSpinner = false;
        this.data.amenity = null;
        this.amenityName = '';
        this.amenityType = '';
        this.residentEmail = '';
        this.residentPhone = '';
        this.residentOccupancy = '';
        this.residentOccupancyDisplayName = '';
        this.termsAndConditions = '';
        this.amenityConfirmationMessage = '';
        this.amenitiesService.buildingsForUpdate.forEach((building) => {
            if (building.id == buildingId) {
                this.data.buildingName = building.name;
                this.data.buildingTimezone = building.timezone;
            }
        });
        this.amenitiesService.getAmenitiesListByBuilding(buildingId);
        this.data.residentId = null;
        this.data.residentFullName = '';
        this.data.suiteId = null;
        this.data.suiteNumber = '';
        this.getSuites(+buildingId);
    }

    changeUnit(suiteId: string) {
        if (+suiteId != this.data.suiteId) {
            this.data.suiteId = +suiteId;
            this.suites.forEach((suite) => {
                if (suite.id == suiteId) this.data.suiteNumber = suite.name;
            });
            this.isEditModeNoSpinner = false;
            this.form.controls['residentId'].reset();
            this.getResidents(+suiteId);
            if (suiteId + '' === '0') {
                this.form.controls['residentId'].setValue(0);
                this.data.residentId = 0;
                this.data.suiteNumber = '';
                this.data.residentFullName = '';
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            this.residentEmail = '';
            this.residentPhone = '';
            this.residentOccupancy = '';
            this.residentOccupancyDisplayName = '';
        }
    }

    changeResident(residentId: string) {
        this.residentEmail = '';
        this.residentPhone = '';
        this.residentOccupancy = '';
        this.residentOccupancyDisplayName = '';
        this.data.isValidEmail = false;
        this.data.residentId = +residentId;
        if (residentId === '0') {
            this.data.residentFullName = '';
            this.data.isPayByLink = false;
        } else {
            const index = this.residents.findIndex(res => res.id == +residentId);
            this.data.residentFullName = this.residents[index].fullName;
            this.residentEmail = this.residents[index].email;
            this.data.isPayByLink = this.residentEmail ? this.data.isPayByLink : false;
            this.data.isValidEmail = this.residents[index].isValidEmail;
            this.residentOccupancy = this.fullResidentsObjectArray[index].suiteUser[0].role;
            this.getOccupancyDisplayName(this.residentOccupancy);
            this.fullResidentsObjectArray[index].phones.forEach(phone => {
                if (phone.isPrimaryPhone)
                    this.residentPhone = phone.phone;
            });
            this.isEditModeNoSpinner = false;
        }
    }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.suites = [];
                this.residents = [];
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId)
                    this.getResidents(suiteId);
                else
                    this.residents = [new ResidentForSelect(0, 'Other')];
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }

    getResidents(suiteId: number): void {
        this.residents = [];
        if (!suiteId) return;
        const url = `/v1/residents.json?per-page=1000&suite_id=${suiteId}&expand=phones,suiteUser`;
        this.api.get('domainBD', url).subscribe(
            res => {
                if (this.data.suiteId !== 0) {
                    this.fullResidentsObjectArray = [];
                    const residents = JSON.parse(res._body).entities;
                    this.fullResidentsObjectArray = residents;
                    this.residents = residents.map(item => (
                        new ResidentForSelect(item.id, item.fullName, [], item.email, item.isValidEmail)
                    ));
                    this.residents.push(new ResidentForSelect(0, 'Other'));

                    if (this.amenitiesService.amenityInAmenityModal) {
                        this.fullResidentsObjectArray.forEach((resident) => {
                            if (resident.id == +this.amenitiesService.amenityInAmenityModal.residentId) {
                                resident.phones.forEach(phone => {
                                    if (phone.isPrimaryPhone)
                                        this.residentPhone = phone.phone;
                                });
                                this.residentEmail = resident.email;
                                this.residentOccupancy = resident.suiteUser[0].role;
                                this.getOccupancyDisplayName(this.residentOccupancy);
                            }
                        });
                    }
                }
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    getBuildingNameById(id): string {
        let name = '';

        this.amenitiesService.buildings.forEach(building => {
            if (building.id == id)
                name = building.name;
        });

        return name;
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    showCalendarDatepicker(dateToSet): void {
        if (!this.gettingAmenityForEditing && !(dateToSet == 'endDay' && !this.data.day)) {
            this.showCustomRepeatWindow = false;
            this.showCalendarDatePicker = !this.showCalendarDatePicker;
            if (this.showCalendarDatePicker) {
                this.dateToSet = dateToSet;
                setTimeout(() => {
                    const that = this;
                    $('#modalCalendar').fullCalendar(this.calendarOptions);
                    $('#modalCalendar').on('click', function (event) {
                        that.onDayClick(event);
                    });
                    if (dateToSet == 'endDay' && this.data.day) {
                        const goToDate = moment(this.data.endDay ? this.data.endDay.split('.')[1] + '.' + this.data.endDay.split('.')[0] + '.' + this.data.endDay.split('.')[2] :
                            this.data.day.split('.')[1] + '.' + this.data.day.split('.')[0] + '.' + this.data.day.split('.')[2], 'MM.DD.YYYY');
                        $('#modalCalendar').fullCalendar('gotoDate', goToDate);
                    } else if (dateToSet == 'day' && this.data.day) {
                        const goToDate = moment(this.data.day.split('.')[1] + '.' + this.data.day.split('.')[0] + '.' + this.data.day.split('.')[2], 'MM.DD.YYYY');
                        $('#modalCalendar').fullCalendar('gotoDate', goToDate);
                    }
                }, 150);
                setTimeout(() => {
                    this.modifyCalendarHeaderRow();
                    this.getEventsAndDayColoringsForMonthSelected(this.dateToSet);
                }, 300);
            }
        } else if (dateToSet == 'endDay' && !this.data.day && this.showCalendarDatePicker)
            this.showCalendarDatePicker = false;
    }

    modifyCalendarHeaderRow(): void {
        const headerRowCells = document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;
        for (let i = 0; i < headerRowCells.length; i++)
            (<any>headerRowCells[i]).innerText = (<any>headerRowCells[i]).innerText.substr(0, 1);
    }

    modifyCalendarCellsColoring(dateToSet): void {
        this.showCalendarSpinner = true;
        const daysRows = document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;
        for (let m = 0; m < daysRows.length; m++) {
            const daysInRow = daysRows[m].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes;
            for (let n = 0; n < daysInRow.length; n++) {
                const tableCell = (<any>daysInRow[n]);
                if (tableCell.classList && tableCell.classList.value.indexOf('fc-day-top') != -1) {
                    if (tableCell.innerText <= this.arrayForCalendarColoring.length) {
                        tableCell.classList += ' ' + (this.arrayForCalendarColoring[parseInt(tableCell.innerText) - 1].toLowerCase()).replace(' ', '-');
                        tableCell.childNodes[0].classList += ' ' + (this.arrayForCalendarColoring[parseInt(tableCell.innerText) - 1].toLowerCase()).replace(' ', '-');
                        const calendarDay = parseInt(tableCell.innerText);
                        const calendarMonth = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[0]);
                        const calendarYear = parseInt((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[1]);
                        if (dateToSet == 'endDay' && (new Date(calendarYear, calendarMonth, calendarDay) < new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])))) {
                            tableCell.classList += ' ' + 'closed';
                            tableCell.childNodes[0].classList += ' ' + 'closed';
                        }
                        if (dateToSet == 'endDay' && this.amenityType == 'hourly' && this.nextDayEndTimes.length &&
                            ((new Date(calendarYear, calendarMonth, calendarDay).getTime() - new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime()) > 60000 * 60 * 24)) {
                            tableCell.classList += ' ' + 'closed';
                            tableCell.childNodes[0].classList += ' ' + 'closed';
                        }
                        if (dateToSet == 'endDay' && this.amenityType == 'daily' && (new Date(calendarYear, calendarMonth, calendarDay).getTime() == new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime())) {
                            tableCell.classList += ' ' + 'closed';
                            tableCell.childNodes[0].classList += ' ' + 'closed';
                        }
                    }
                }
            }
        }
        this.showCalendarSpinner = false;
        (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = false;
        (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = false;
    }

    onDayClick(event): void {
        let element;
        if (event.toElement)
            element = event.toElement;
        else if (event.target)
            element = event.target;

        if (element.className.indexOf('fc-day-number') != -1 && element.className.indexOf(' booked') == -1
            && element.className.indexOf('closed') == -1 && !this.showCalendarSpinner) {
            if (this.dateToSet == 'day') {
                this.startHour = '';
                this.endHour = '';
            } else
                this.endHour = '';
            this.timeSlot = '';
            let month = (<any>document.getElementsByClassName('fc-center')).length > 1 ? (<any>document.getElementsByClassName('fc-center')[1].childNodes[0].childNodes[1]).innerHTML : (<any>document.getElementsByClassName('fc-center')[0].childNodes[0].childNodes[1]).innerHTML;
            const day = element.innerText;
            const year = month.substr(month.indexOf(' ') + 1, 4);
            month = this.monthsArray.indexOf(month.substr(0, month.indexOf(' '))) + 1;
            if (this.dateToSet == 'day')
                this.amenitiesService.prefilledDateFromCaledar = '';
            this.data[this.dateToSet] = ((day < 10 ? '0' + day : day) + '.' + (month < 10 ? '0' + month : month) + '.' + year);
            if (this.dateToSet == 'day' && this.data.endDay)
                this.data.endDay = '';
            if (this.dateToSet == 'day' && this.amenityType == 'hourly')
                this.data.endDay = this.data.day;
            this.showCalendarDatePicker = false;
            if (this.amenityType == 'hourly' || this.amenityType == 'range') {
                const date = this.data.day.split('.')[2] + '-' + this.data.day.split('.')[1] + '-' + this.data.day.split('.')[0];
                const timeString = this.getTwentyFourHourTime(this.startHour ? this.startHour.time : '');
                const startDateForSending = moment(date).format('YYYY-MM-DDT' + timeString);
                const endDateForSending = moment(date).add(1, 'day').format('YYYY-MM-DDT23:59');
                this.getTimeSelectValues(startDateForSending, endDateForSending, this.dateToSet);
            }
        } else if ((element.className.indexOf('fc-icon-left-single-arrow') != -1 ||
            element.className.indexOf('fc-icon-right-single-arrow') != -1 ||
            element.className.indexOf('fc-prev-button') != -1 ||
            element.className.indexOf('fc-next-button') != -1) && !this.showCalendarSpinner) {
            this.modifyCalendarHeaderRow();
            this.getEventsAndDayColoringsForMonthSelected(this.dateToSet);
        }
    }

    moveToElementAndFocus(name) {
        const element = document.getElementsByName(name);
        $(element)[0].scrollIntoView();
        $(element)[0].focus();
    }

    moveToTheNextStep(moveTo): void {
        console.log(moveTo);
        console.log(this);
        if (this.step == 'quotes')
            return;
        if (this.step == 'details') {
            this.showCalendarDatePicker = false;
            if (moveTo == 'terms' || moveTo == 'payment' || moveTo == 'summary') {
                if (!(((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                    (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                    ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                    this.amenityType && ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                        (this.amenityType == 'hourly' ? this.data.day && this.data.endDay && this.startHour && this.endHour : true) &&
                        (this.amenityType == 'range' ? this.timeSlot : true)))
                ) {
                    if (!this.authService.userIsResident && !(this.data.suiteId || this.data.suiteNumber))
                        this.moveToElementAndFocus((<any>this.data.suiteId) != '0' ? 'suiteId' : 'otherSuite');
                    else if (!this.authService.userIsResident && !(this.data.residentFullName || this.data.residentId))
                        this.moveToElementAndFocus((<any>this.data.residentId) != '0' ? 'residentId' : 'otherResident');
                    else if (this.bookingType == 'event' && !this.eventName)
                        this.moveToElementAndFocus('eventName');
                    else if (!this.data.day)
                        this.moveToElementAndFocus('day');
                    else if (this.amenityType == 'daily' && !(this.data.day && this.data.endDay))
                        this.moveToElementAndFocus(!this.data.day ? 'day' : 'endDay');
                    else if (this.amenityType == 'hourly' && this.bookingType != 'event' && !(this.data.day && this.data.endDay && this.startHour && this.endHour))
                        this.moveToElementAndFocus('startHour');
                    else if (this.amenityType == 'range' && this.bookingType != 'event')
                        this.moveToElementAndFocus('range');
                    else if (this.bookingType == 'event' && (this.amenityType == 'hourly' || this.amenityType == 'range') && !this.maxNumberOfParticipants)
                        this.moveToElementAndFocus('maxNumberOfParticipants');

                    return;
                }
            }
        }
        if (moveTo == 'amenity') {
            if (!this.isEditMode)
                this.step = moveTo;
        }
        if (moveTo == 'terms') {
            if (this.step == 'amenity') {
                if (!this.data.buildingId || !this.data.amenity)
                    return;
            }
            this.step = moveTo;
            this.form.submitted = false;
        }
        if (moveTo == 'details') {
            if (this.data.buildingId && this.data.amenity &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage)) {
                this.step = moveTo;
                this.form.submitted = false;
            }
        }
        if (moveTo == 'disclaimer') {
            if (((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.amenityType && ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                    (this.amenityType == 'hourly' ? this.data.day && this.data.endDay && this.startHour && this.endHour : true) &&
                    (this.amenityType == 'range' ? this.timeSlot : true))
            ) {
                this.form.submitted = false;
                this.step = moveTo;
            }
        }
        if (moveTo == 'payment') {
            if (((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.data.day && this.data.amenity &&
                ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                    (this.amenityType == 'hourly' ? this.data.day && this.data.endDay
                        && this.startHour && this.endHour : true) &&
                    (this.amenityType == 'range' ? this.timeSlot : true))
            ) {
                this.form.submitted = false;
                this.step = moveTo;
            }
        }
        if (moveTo == 'summary') {
            if (((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.amenityType && ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                    (this.amenityType == 'hourly' ? this.data.day && this.data.endDay
                        && this.startHour && this.endHour : true) &&
                    (this.amenityType == 'range' ? this.timeSlot : true) &&
                    !(this.data.paymentMethod == 'credit_card' && !this.creditCardToken && !this.data.isPayByLink && this.amenityFees.length > 0 && this.includedFieldsExist()))
            ) {
                this.form.submitted = false;
                this.step = moveTo;
            }

            if (this.data.payments && this.data.paymentMethod == 'credit_card' && !this.creditCardToken && !this.data.isPayByLink)
                toastr.warning('Credit Card details must be filled and applied before moving forward.');
        }
        if (moveTo == 'quotes') {
            if (((!this.authService.userIsResident && (this.bookingType == 'event' || (this.data.suiteId || this.data.suiteNumber) &&
                (this.data.residentFullName || this.data.residentId))) || this.authService.userIsResident) &&
                ((this.amenityConfirmationMessage && this.data.acknowledgement) || !this.amenityConfirmationMessage) &&
                this.amenityType && ((this.amenityType == 'daily' ? this.data.day && this.data.endDay : true) &&
                    (this.amenityType == 'hourly' ? this.data.day && this.data.endDay
                        && this.startHour && this.endHour : true) &&
                    (this.amenityType == 'range' ? this.timeSlot : true) &&
                    !(this.data.paymentMethod == 'credit_card' && !this.creditCardToken && !this.data.isPayByLink && this.amenityFees.length > 0 && this.includedFieldsExist()))
            ) {
                this.form.submitted = false;
                this.step = moveTo;
                this.quoteStep = 'price-list';
                this.showQuote();
            }

            if (this.data.payments && this.data.paymentMethod == 'credit_card' && !this.creditCardToken && !this.data.isPayByLink)
                toastr.warning('Credit Card details must be filled and applied before moving forward.');
        }
    }

    selectAmenity(amenity): void {
        this.termsAndConditions = '';
        this.disclaimerText = '';
        this.disclaimerHideFromStaffInterface = 0;
        this.amenityConfirmationMessage = '';
        this.data.amenity = amenity.id;
        this.data.isEvent = amenity.isEvent ? true : false;
        this.amenityName = amenity.name;
        this.legalAgreementStatus = null;
        this.disclaimerStatus = null;

        if ((!this.authService.userIsResident && amenity.legalAgreementStatus && amenity.legalAgreement && !amenity.legalAgreementHideFromStaffInterface)
            || (this.authService.userIsResident && amenity.legalAgreementStatus && amenity.legalAgreement)) {
            this.legalAgreementStatus = amenity.legalAgreementStatus;
            this.termsAndConditions = amenity.legalAgreement;
            this.amenityConfirmationMessage = amenity.confirmationMessage;
        }
        if ((!this.authService.userIsResident && amenity.disclaimerStatus && !amenity.disclaimerHideFromStaffInterface)
            || (this.authService.userIsResident && amenity.disclaimerStatus)) {
            this.disclaimerStatus = amenity.disclaimerStatus;
            this.disclaimerText = amenity.disclaimer;
            this.disclaimerHideFromStaffInterface = amenity.disclaimerHideFromStaffInterface;
        }

        this.data.managementOverride = false;
        this.data.paymentMethod = '';
        this.availablePaymentMethods = [];
        this.data.day = this.amenitiesService.prefilledDateFromCaledar ? this.amenitiesService.prefilledDateFromCaledar : '';
        this.data.endDay = '';
        this.data.uses = '';
        this.timeSlot = '';
        this.originalRules = null;
        this.startHour = '';
        this.endHour = '';
        this.checkInHour = '';
        this.checkOutHour = '';
        this.amenityFees = [];
        this.bookingMinHour = null;
        this.bookingMaxHour = null;
        this.amenityType = amenity.timeSequenceType;
        this.daySelectedNumber = this.amenitiesService.prefilledDateFromCaledar ? this.daySelectedNumber : null;
        this.originalRules = amenity.rule;
        this.availableUses = amenity.uses ? amenity.uses : [];
        this.overrideAvailable = amenity.managementOverride;
        this.multipleBookingAllowed = amenity.multipleBooking;
        this.minTimeForAdvancedBooking = amenity.minTimeForAdvancedBooking;
        if (this.availableUses.length)
            this.data.uses = this.availableUses[0];
        if (this.bookingType != 'event' && !amenity.isEvent) {
            amenity.fees.forEach(payment => {
                if (payment.active) {
                    this.amenityFees.push({
                        id: payment.id,
                        active: payment.active,
                        name: payment.name,
                        status: payment.status,
                        amount: payment.amount,
                        required: payment.required,
                        include: !!payment.required,
                        refundable: payment.refundable,
                        pmtAtTime: payment.pmtAtTime,
                        pmtHourly: payment.pmtHourly,
                        waived: false,
                        availableWaive: payment.availableWaive
                    });
                }
            });
        }

        if (amenity.paymentAcceptCash) {
            this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
        }
        if (amenity.paymentAcceptCheques) {
            this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
        }
        if (amenity.paymentAcceptCreditCards) {
            this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
        }
        if (amenity.paymentAcceptCertifiedCheque) {
            this.availablePaymentMethods.push({value: 'certified_cheque', displayName: 'Certified Cheque'});
        }
        if (amenity.paymentAcceptMoneyOrder) {
            this.availablePaymentMethods.push({value: 'money_order', displayName: 'Money Order'});
        }
        if (amenity.paymentAcceptBankDraft) {
            this.availablePaymentMethods.push({value: 'bank_draft', displayName: 'Bank Draft'});
        }
        if (amenity.paymentAcceptCustomType) {
            this.availablePaymentMethods.push({value: 'custom_type', displayName: amenity.paymentCustomTypeName});
        }
        if (amenity.defaultPaymentMethod) {
            this.data.paymentMethod = amenity.defaultPaymentMethod;
        }

        if (this.amenityType == 'daily') {
            this.checkInHour = amenity.rule.checkInTime;
            this.checkOutHour = amenity.rule.checkOutTime;
        }
        if (this.amenityType == 'hourly') {
            this.bookingMaxHour = amenity.rule.bookingMaxHour;
            this.bookingMinHour = amenity.rule.bookingMinHour;
            if (this.amenitiesService.prefilledDateFromCaledar)
                this.getOvernightEndHours();
        }
        if ((this.amenityType == 'hourly' || this.amenityType == 'range') && this.amenitiesService.prefilledDateFromCaledar) {
            const date = this.data.day.split('.')[2] + '-' + this.data.day.split('.')[1] + '-' + this.data.day.split('.')[0];
            const startDateForSending = moment(date).format('YYYY-MM-DDT00:00');
            const endDateForSending = moment(date).format('YYYY-MM-DDT23:59');
            this.getTimeSelectValues(startDateForSending, endDateForSending, 'day');
        }

        if (amenity.isEvent) {
            this.data.day = amenity.dateFrom;
            this.data.endDay = amenity.dateTo;
            this.amenityType = 'eventBooking';
        }
    }

    isStartHourDisabled(hour): boolean {
        let disableOption = !this.data.managementOverride && !hour.available;
        const bookingStartDate = new Date(
            parseInt(this.data.day.split('.')[2]),
            parseInt(this.data.day.split('.')[1]) - 1,
            parseInt(this.data.day.split('.')[0])
        ).getTime();
        // NEEDS FIX ON BACK END FOR KNOWING CLIENTS TIMEZONE!!! Disables the time that is earlier than current time.
        if (bookingStartDate == new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime()) {
            const currentDate = new Date();
            const currentTime = new Date(`01/01/1970 ${currentDate.getHours() + ':' + currentDate.getMinutes()}`);
            if (currentTime > (new Date(`01/01/1970 ${hour.time}`)))
                disableOption = true;
        }
        return disableOption;
    }

    isEndHourDisabled(hour): boolean {
        if (this.startHour) {
            const day = this.data.day == this.data.endDay ? '01' : '02';
            return new Date(`${day}/01/1970 ${hour.time}`) <= new Date(`01/01/1970 ${this.startHour.time}`) || (!this.data.managementOverride && !hour.available);
        }
    }

    getFormattedPhone(phone): string {
        let phoneString = '';

        if (phone.length == 10)
            phoneString = phone.substr(0, 3) + ' ' + phone.substr(3, 3) + ' ' + phone.substr(6, 4);
        else if (phone.length == 11)
            phoneString = '+' + phone.substr(0, 1) + ' ' + phone.substr(1, 3) + ' ' + phone.substr(4, 3) + ' ' + phone.substr(7, 4);
        else
            phoneString = phone;

        return phoneString;
    }

    isContinueButtonDisabled(step): boolean {
        let isDisabled = true;

        if (step == 'amenity') {
            if (this.data.buildingId && this.data.amenity)
                isDisabled = false;
        }
        if (step == 'disclaimer') {
            if (this.amenityConfirmationMessage) {
                isDisabled = false;
            } else
                isDisabled = false;
        }
        if (step == 'details') {
            if (((this.data.suiteId || this.data.suiteNumber) && (this.data.residentId || this.data.residentFullName) || this.bookingType == 'event' || this.data.isEvent)
                && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true))
                isDisabled = false;
            if (this.authService.userIsResident && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true))
                isDisabled = false;
        }
        if (step == 'terms') {
            if (this.amenityConfirmationMessage) {
                if (this.data.acknowledgement)
                    isDisabled = false;
            } else
                isDisabled = false;
        }
        if (step == 'payment') {
            if (this.authService.userIsResident && this.data.amenity && this.data.day &&
                (this.amenityType == 'daily' ? this.data.endDay : true)) {
                isDisabled = false;
            }

            if (((this.data.suiteId || this.data.suiteNumber) && (this.data.residentId || this.data.residentFullName) || this.bookingType == 'event' || this.data.isEvent)
                && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true)) {
                if (this.amenityConfirmationMessage) {
                    if (this.data.acknowledgement)
                        isDisabled = false;
                } else
                    isDisabled = false;
            }
        }
        if (step == 'summary') {
            if (((this.data.suiteId || this.data.suiteNumber) && (this.data.residentId || this.data.residentFullName) || this.bookingType == 'event' || this.data.isEvent)
                && this.data.amenity && this.data.day && (this.amenityType == 'daily' ? this.data.endDay : true)) {
                if (this.amenityConfirmationMessage) {
                    if (this.data.acknowledgement)
                        isDisabled = false;
                } else
                    isDisabled = false;
            }
            if (this.authService.userIsResident && this.data.amenity && this.data.day &&
                (this.amenityType == 'daily' ? this.data.endDay : true))
                isDisabled = false;
        }

        return isDisabled;
    }

    getEventsAndDayColoringsForMonthSelected(dateToSet): void {
        this.showCalendarSpinner = true;
        (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = true;
        (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = true;
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[0]) + 1;
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[1]);
        const startDateForSending = yearChangedTo + '-' + (monthChangedTo > 9 ? monthChangedTo : '0' + monthChangedTo) + '-01' + 'T00:00';
        this.arrayOfMonthsLastDays[1] = yearChangedTo % 4 == 0 ? 29 : 28;
        const endDateForSending = yearChangedTo + '-' + (monthChangedTo > 9 ? monthChangedTo : '0' + monthChangedTo) + '-' + this.arrayOfMonthsLastDays[monthChangedTo - 1] + 'T23:59';
        let url = `/v1/amenity_available/${this.data.amenity}/by_date.json?begin_date=${startDateForSending}&end_date=${endDateForSending}`;
        if (dateToSet == 'endDay') {
            const timeString = this.getTwentyFourHourTime(this.startHour ? this.startHour.time : '');
            const booking_date_from = this.data.day.split('.')[2] + '-' + this.data.day.split('.')[1] + '-' + this.data.day.split('.')[0] + 'T' + timeString;
            url += `&booking_date_from=${booking_date_from}`;
        }
        if (!this.data.managementOverride) {
            this.api.get('domainAmenities', url).subscribe(
                res => {
                    this.arrayForCalendarColoring = [];
                    const entities = JSON.parse(res._body);
                    entities.forEach(entity => {
                        this.arrayForCalendarColoring.push(entity.status);
                    });
                    this.modifyCalendarCellsColoring(dateToSet);
                },
                error => {
                    this.api.errorHandler(error, 'Failed get Bookings for month selected');
                    (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = false;
                    (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = false;
                }
            );
        } else
            this.modifyCalendarCellsColoringForOverrideMode(dateToSet);
    }

    modifyCalendarCellsColoringForOverrideMode(dateToSet) {
        this.showCalendarSpinner = true;
        const daysRows = document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[1].childNodes[0].childNodes[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes[0].childNodes;
        for (let m = 0; m < daysRows.length; m++) {
            const daysInRow = daysRows[m].childNodes[1].childNodes[0].childNodes[0].childNodes[0].childNodes;
            for (let n = 0; n < daysInRow.length; n++) {
                const tableCell = (<any>daysInRow[n]);
                if (tableCell.classList && tableCell.classList.value.indexOf('fc-day-top') != -1) {
                    const calendarDay = parseInt(tableCell.innerText);
                    const calendarMonth = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[0]);
                    const calendarYear = parseInt((<any>document.getElementsByClassName('calendar-datepicker')[0].childNodes[5].childNodes[0].childNodes[2].childNodes[0].childNodes[1]).innerText.split(' ')[1]);
                    const currentDay = this.getTimeInZeroTimezone(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).getTime();
                    const calendarDayUTC = this.getTimeInZeroTimezone(new Date(calendarYear, calendarMonth, calendarDay)).getTime();
                    if (calendarDayUTC < currentDay) {
                        tableCell.classList += ' ' + 'closed';
                        tableCell.childNodes[0].classList += ' ' + 'closed';
                    } else {
                        tableCell.classList += ' available';
                        tableCell.childNodes[0].classList += ' available';
                    }
                }
            }
        }
        this.showCalendarSpinner = false;
        (<any>document.getElementsByClassName('fc-prev-button')[0]).disabled = false;
        (<any>document.getElementsByClassName('fc-next-button')[0]).disabled = false;
    }

    addDayToRepeatArray(day) {
        if (this.repeatOn.indexOf(day) == -1)
            this.repeatOn.push(day);
        else
            this.repeatOn.splice(this.repeatOn.indexOf(day), 1);
    }

    showCustomRepeat(): void {
        this.showCalendarDatePicker = false;
        this.showCustomRepeatWindow = true;
    }

    convertDayBookingStartEnd(dateValue, timeValue): any {
        const date = new Date(dateValue);
        const timeObj = this.getTimeInZeroTimezone(timeValue);
        const utcDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), timeObj.getHours(), timeObj.getMinutes());
        return new Date(utcDate);
    }

    changePaymentType(event): void {
        if (event == 'credit_card')
            this.amenityFees.forEach(fee => fee.status = false);
        this.creditCardToken = null;
    }

    getTotalRefundableValue(): any {
        let returnValue = 0;
        this.amenityFees.forEach((fee) => {
            if (fee.include && fee.active && fee.refundable && !fee.waived)
                returnValue += parseFloat(fee.amount.replace(',', '.'));
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getIndividualReservationProcessingFee(fee): any {
        return fee != '0.00' ? ((((parseFloat(fee) * 1.01) + 0.3) / 0.971) - parseFloat(fee)) : 0;
    }

    getReservationProcessingFeeValue(): any {
        let returnValue = 0;
        returnValue = this.getTotalPaymentValue() != '0.00' ? ((parseFloat(this.getTotalPaymentValue()) * 1.01 + 0.3) / 0.971) - parseFloat(this.getTotalPaymentValue()) : 0;
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getTotalPaymentValue(): any {
        let returnValue = 0;
        this.amenityFees.forEach((fee) => {
            if (fee.include && fee.active && !fee.refundable && !fee.waived) {
                if (!fee.pmtAtTime && !fee.pmtHourly)
                    returnValue += parseFloat(fee.amount.replace(',', '.'));
                else if (fee.pmtAtTime)
                    returnValue += parseFloat(fee.amount.replace(',', '.')) * this.getStartEndDayDifference();
                else if (fee.pmtHourly)
                    returnValue += parseFloat(fee.amount.replace(',', '.')) * this.getStartEndHourDifference();
            }
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getTotalCharged(): any {
        return parseFloat((parseFloat(this.getTotalPaymentValue()) + (this.data.paymentMethod == 'credit_card' ? parseFloat(this.getReservationProcessingFeeValue()) : 0)).toString()).toFixed(2);
    }

    getStartEndDayDifference(): number {
        return Math.round((new Date(parseInt(this.data.endDay.split('.')[2]), parseInt(this.data.endDay.split('.')[1]) - 1, parseInt(this.data.endDay.split('.')[0])).getTime() -
            new Date(parseInt(this.data.day.split('.')[2]), parseInt(this.data.day.split('.')[1]) - 1, parseInt(this.data.day.split('.')[0])).getTime()) / (24 * 3600000));
    }

    getStartEndHourDifference(): number {
        const startDay = `${this.data.day.slice(-4)}/${this.data.day.slice(3, 5)}/${this.data.day.slice(0, 2)}`;
        const endDay = `${this.data.endDay.slice(-4)}/${this.data.endDay.slice(3, 5)}/${this.data.endDay.slice(0, 2)}`;
        return (+moment.utc(moment(endDay + ` ${this.endHour.time}`).diff(moment(startDay + ` ${this.startHour.time}`))).format('x')) / (60 * 60 * 1000);
    }

    getPaymentsFormatted(): Array<any> {
        const formatted = [];
        this.amenityFees.forEach((fee) => {
            let total = '';
            if (fee.pmtAtTime)
                total = (this.getStartEndDayDifference() * parseFloat(fee.amount)).toString();
            else if (fee.pmtHourly)
                total = (this.getStartEndHourDifference() * parseFloat(fee.amount)).toString();
            else
                total = fee.amount;
            formatted.push({
                fee: fee.id,
                chosen: fee.include ? 1 : 0,
                name: fee.name,
                status: this.data.id ? undefined : (fee.status ? 1 : 0),
                paymentType: this.data.paymentMethod,
                amount: fee.amount,
                total: total,
                refundable: fee.refundable ? 1 : 0,
                waived: fee.waived ? 1 : 0,
                cardToken: this.data.paymentMethod == 'credit_card' && !this.data.isPayByLink && this.includedFieldsExist() ? this.creditCardToken : undefined
            });
        });
        return formatted;
    }

    ifRequired(fee) {
        let required = false;
        this.amenityFees.forEach((amenityFee) => {
            if (amenityFee.name == fee.name)
                required = amenityFee.required;
        });
        return required;
    }

    setCard(card) {
        if (!this.data.isPayByLink)
            this.creditCardToken = card;
    }

    onStripeSuccess() {
        if (this.showQuoteCheckbox())
            this.showQuote();
        else
            this.moveToTheNextStep('summary');
    }

    clickStripeHiddenButton() {
        document.getElementById('confirmStripeCreditCard').click();
    }

    getOvernightEndHours(): void {
        this.nextDayEndTimes = [];
        let dayEndsAtMidnight = false;
        let index = -1;
        const date = moment(this.data.day.split('.')[2] + '-' + this.data.day.split('.')[1] + '-' + this.data.day.split('.')[0]);
        const daySelectedNumber = parseInt(date.format('d'));
        for (let i = 0; i < this.originalRules.weekDays.length; i++) {
            if (this.originalRules.weekDays[i].dayNumber == daySelectedNumber) {
                dayEndsAtMidnight = this.originalRules.weekDays[i].dayHours.some(
                    hours => hours.maxHour == '1970-01-02T00:00:00+00:00'
                );
            }
        }
        if (dayEndsAtMidnight) {
            for (let i = 0; i < this.originalRules.weekDays.length; i++) {
                if (this.originalRules.weekDays[i].dayNumber == (daySelectedNumber == 7 ? 1 : daySelectedNumber + 1)) {
                    index = i;
                    break;
                }
            }
        }
        if (index != -1) {
            let overnightDayHours = null;
            this.originalRules.weekDays[index].dayHours.forEach((hours) => {
                if (new Date(hours.minHour).getTime() == 0)
                    overnightDayHours = hours;
            });
            if (overnightDayHours) {
                const timestep = this.originalRules.timeStep;
                const minHour = new Date(overnightDayHours.minHour);
                const maxHour = new Date(overnightDayHours.maxHour);
                const startHour = this.getTimeInZeroTimezone(minHour).getHours();
                const endHour = this.getTimeInZeroTimezone(maxHour).getHours();
                const startMinutes = minHour.getMinutes();
                const endMinutes = maxHour.getMinutes() + 1;
                for (let i = startHour; i < endHour + 1; i++) {
                    for (let j = startMinutes; j < ((i + 1 == endHour + 1) ? endMinutes : 60); j += timestep) {
                        if (j < 60) {
                            const hour = (i <= 12 ? (i == 0 ? 12 : i) : i - 12);
                            const minutes = (j < 10 ? '0' + j : j);
                            const amPm = (i < 12 || i == 24 ? ' AM' : ' PM');
                            this.nextDayEndTimes.push((hour < 10 ? '0' + hour : hour) + ':' + minutes + amPm);
                        }
                    }
                }
            } else
                this.nextDayEndTimes.push('12:00 AM');
        } else
            this.data.endDay = this.data.day;
    }

    endDateEqualsStartDate(): boolean {
        let flag = true;
        if (this.data.endDay) {
            const startDate = new Date(
                parseInt(this.data.day.split('.')[2]),
                parseInt(this.data.day.split('.')[1]),
                parseInt(this.data.day.split('.')[0])
            ).getTime();
            const endDate = new Date(
                parseInt(this.data.endDay.split('.')[2]),
                parseInt(this.data.endDay.split('.')[1]),
                parseInt(this.data.endDay.split('.')[0])
            ).getTime();
            if (startDate != endDate)
                flag = false;
        }
        return flag;
    }

    removePaidStatus(event, fee) {
        if (!event)
            fee.status = 0;
    }

    // TODO: deprecated
    calculateCurrentProgressBarLength(): string {
        const termsAndConsitionsStepExist = this.termsAndConditions || this.amenityConfirmationMessage;
        const paymentStepExist = this.availablePaymentMethods.length && this.amenityFees.length;
        if (this.step == 'amenity') {
            if (!paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '17%';
            if (paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '13%';
            if (paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '11%';
            if (!paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '11%';
            if (paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '11%';
            if (!paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '13%';
            if (!paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '13%';
            if (paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '9%';
        }

        if (this.step == 'disclaimer') {
            if (!paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '30%';
            if (paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '50%';
            if (!paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '63%';
            if (paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '59%';
        }
        if (this.step == 'details') {
            if (!paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '50%';
            if (paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '38%';
            if (paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '50%';
            if (!paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '50%';
            if (paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '30%';
            if (!paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '38%';
            if (!paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '38%';
            if (paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '42%';
        }
        if (this.step == 'terms') {
            if (paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '29%';
            if (!paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '71%';
            if (!paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '61%';
            if (paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '24%';
        }
        if (this.step == 'payment') {
            if (paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '63%';
            if (paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '70%';
            if (paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '71%';
            if (paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '76%';
        }
        if (this.step == 'summary' || this.step == 'quotes') {
            if (!paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '84%';
            if (paymentStepExist && !termsAndConsitionsStepExist && !this.disclaimerText) return '88%';
            if (paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '91%';
            if (!paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '91%';
            if (paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '91%';
            if (!paymentStepExist && !termsAndConsitionsStepExist && this.disclaimerText) return '88%';
            if (!paymentStepExist && termsAndConsitionsStepExist && !this.disclaimerText) return '88%';
            if (paymentStepExist && termsAndConsitionsStepExist && this.disclaimerText) return '92%';
        }
    }

    overrideSettingChanged(event) {
        this.showCalendarDatePicker = false;
        if (!event) {
            this.data.day = '';
            this.data.endDay = '';
            this.timeRangeSelectValues = [];
        }
        this.timeSlot = '';
        this.rangeOverrideStartHour = '';
        this.rangeOverrideEndHour = '';
        if (this.amenityType == 'hourly') {
            if (!event) {
                this.startHour = '';
                this.endHour = '';
            }
        }
    }

    getTimeInZeroTimezone(date): any {
        return new Date(new Date(date).getTime() + new Date(date).getTimezoneOffset() * 60000);
    }

    imageIsSvg(amenityImage) {
        return amenityImage.indexOf('.svg') != -1;
    }

    getResidentPrimaryPhone(phones) {
        if (phones.length > 0) {
            const primary = phones.find(p => p.isPrimaryPhone);
            return primary ? primary.phone : phones[0].phone;
        } else
            return '';
    }

    getOccupancyDisplayName(residentOccupancy) {
        if (residentOccupancy == 'owner_off')
            this.residentOccupancyDisplayName = 'Owner Off-Site';
        else if (residentOccupancy == 'owner_on')
            this.residentOccupancyDisplayName = 'Owner On-Site';
        else if (residentOccupancy == 'rent')
            this.residentOccupancyDisplayName = 'Tenant';
        else if (residentOccupancy == 'occupant')
            this.residentOccupancyDisplayName = 'Occupant';
        else if (residentOccupancy == 'resident')
            this.residentOccupancyDisplayName = 'Resident';
        else if (residentOccupancy == 'offsite_resident')
            this.residentOccupancyDisplayName = 'Offsite Resident';
        else if (residentOccupancy == 'guest')
            this.residentOccupancyDisplayName = 'Guest';
        else if (residentOccupancy == 'resident_owner')
            this.residentOccupancyDisplayName = 'Resident Owner';
        else if (residentOccupancy == 'resident_only_not_on_deed')
            this.residentOccupancyDisplayName = 'Resident Only Not On Deed';
        else if (residentOccupancy == 'owner_family')
            this.residentOccupancyDisplayName = 'Owner Family';
        else if (residentOccupancy == 'unknown')
            this.residentOccupancyDisplayName = 'Not Set';
        else
            this.residentOccupancyDisplayName = '';
    }

    showQuoteModal() {
        const amenity = this.amenitiesService.amenitiesByBuilding.find(a => a.id == this.data.amenity);
        const building = amenity.buildingAmenity.find(b => b.buildingId == this.data.buildingId);
        const amenityName = amenity.name.toLowerCase();

        if (amenityName.indexOf('elevator') != -1) {
            // this.amenitiesService.quoteModalType = 'elevator';
            // this.amenitiesService.showQuoteModal = true;
            // this.amenitiesService.quoteModalObject = {
            const data = {
                uses: this.data.uses,
                phone: this.getResidentPrimaryPhone(this.residentService.selectedBuilding.userPhones),
                startDate: this.data.day,
                residentFullName: this.residentService.selectedBuilding.userName,
                buildingId: building.buildingId,
                buildingName: building.buildingName,
                buildingAddress: building.buildingAddress,
                suiteId: Number(this.residentService.selectedBuilding.suite_id),
                suiteNumber: this.residentService.selectedBuilding.suiteNumber,
                corporationId: building.corporationNumberBd,
                amenityName: amenity.name
            };
            this.getQuote(data);
        }
    }

    isOverrideEndHourDisabled(hour) {
        if (this.rangeOverrideStartHour)
            return new Date(`01/01/1970 ${hour}`) <= new Date(`01/01/1970 ${this.rangeOverrideStartHour}`);
        else
            return false;
    }

    rangeOverrideStartHourChange() {
        this.timeSlot = '';
        this.rangeOverrideEndHour = '';
    }

    rangeOverrideEndHourChange() {
        this.timeSlot = this.rangeOverrideStartHour + ' - ' + this.rangeOverrideEndHour;
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }

    getQuote(data) {
        const url = `${environment.domainQuotes}?type=${data.uses}&phone=${data.phone}&date=${data.startDate}&name=${data.residentFullName}&address=${data.buildingName}&corp=${data.corporationId}`;
        const userAgent = window.navigator.userAgent;
        if (userAgent.indexOf('Safari') != -1 &&
            (userAgent.indexOf('iPhone') != -1 || userAgent.indexOf('iPad') != -1 || userAgent.indexOf('iPod') != -1))
            window.location.href = url;
        else
            window.open(encodeURI(url));
    }

    showQuoteCheckbox() {
        return false;
        // return this.authService.userIsResident && this.isElevator() &&
        //        (this.isMoveIn() || this.isMoveOut());
    }

    private isElevator(): boolean {
        return this.amenityName.toLowerCase().indexOf('elevator') != -1;
    }

    private isMoveIn(): boolean {
        return this.data.uses.toLowerCase().indexOf('move in') != -1;
    }

    private isMoveOut(): boolean {
        return this.data.uses.toLowerCase().indexOf('move out') != -1;
    }

    getNewQuote(approved) {
        if (!approved) {
            if (!this.answers.some(a => a.checked)) {
                toastr.warning('Please, check at least one option');
                return;
            }
            if (this.answers[4].checked && !this.otherReason) {
                toastr.warning('Please, fill the other reason field.');
                return;
            }
        }

        this.sendQuoteEmail(approved);

        this.quoteStep = 'price-list';
        this.step = 'summary';
    }

    private sendQuoteEmail($isApproved) {
        try {
            if (this.isMoveIn() || this.isMoveOut()) {
                const amenity = this.amenitiesService.amenitiesByBuilding.find(a => a.id == this.data.amenity);
                const building = amenity.buildingAmenity.find(b => b.buildingId == this.data.buildingId);
                const moveFrom = this.isMoveOut() ? this.residentService.selectedBuilding.buildingAddress : '';
                const moveTo = this.isMoveIn() ? this.residentService.selectedBuilding.buildingAddress : '';
                const reason = !$isApproved ? this.getSelectedAnswersString() : undefined;
                const status = $isApproved ? 'Accepted' : 'Not Accepted';
                const formType = $isApproved ? 'quote_wizard:offer' : 'mcc:get_quote';

                const data = {
                    'Status': status,
                    'Reason': reason,
                    'Date': this.data.day,
                    'Direction': this.isMoveIn() ? 'Move In' : 'Move Out',
                    'Unit size': '',
                    'Resident Name': this.residentService.selectedBuilding.userName,
                    'Phone': this.residentPhone,
                    'Email': this.residentService.selectedBuilding.userEmail,
                    'Move From': moveFrom,
                    'Move To': moveTo,
                    'Corporation': building.corporationNumberName,
                    '--':
                        `<hr>
                        <p>We can help you book experienced movers without a large minimum!<br/>
                        Rate includes 2 movers and a truck.<br/>
                        For the first 1.5 hours - $150<br/>
                        For each additional hour - $99<br/>
                        Appliances, fitness equipment, disposal, storage, stairs and out-of-town moves are extra and will be quoted by your Pro.
                        </p>
                       `
                };

                return this.http.post('https://maxtvmedia.com/condoclub/notice.php', {
                    formName: formType,
                    subject: `Quote Wizard (${status})`,
                    data
                }).subscribe();
            }
        } catch (e) {
            console.log(e);
        }
    }


    showQuote() {
        this.step = 'quotes';
        this.quoteStep = 'price-list';
        if (this.residentService.selectedBuilding.userPhones)
            this.residentPhone = this.getResidentPrimaryPhone(this.residentService.selectedBuilding.userPhones);
    }

    getSelectedAnswersString() {
        let answersString = '';

        this.answers.forEach(a => {
            if (a.checked)
                answersString += a.id != '5' ? (a.answer + '. \n') : this.otherReason;
        });

        return answersString;
    }

    getTimeSelectValues(startDateForSending, endDateForSending, dateToSet) {
        this.showTimeSelectSpinner = true;
        let url = `/v1/amenity_available/${this.data.amenity}/by_date.json?begin_date=${startDateForSending}&end_date=${endDateForSending}`;
        if (dateToSet == 'endDay')
            url += `&booking_date_from=${startDateForSending}`;
        this.api.getJson('domainAmenities', url).subscribe(
            res => {
                this.showTimeSelectSpinner = false;
                if (this.form.value.override) {
                    res = this.generateTimeSelectValuesForOverride(res);
                }
                if (this.amenityType == 'hourly') {
                    if (dateToSet == 'day') {
                        console.log({['this.form.value.override']: this.form.value.override});
                        console.log(this);
                        const x = this;

                        this.startTimeSelectValues = res[0].hours;
                        if (this.amenitiesService.amenityInAmenityModal || this.amenitiesService.prefilledDateFromCaledar)
                            this.startHour = this.startTimeSelectValues.find(t => t.time == this.startHour);
                    } else {
                        const index = this.data.day == this.data.endDay ? 0 : 1;
                        this.endTimeSelectValues = res[index].hours;
                        if (this.amenitiesService.amenityInAmenityModal || this.amenitiesService.prefilledDateFromCaledar)
                            this.endHour = this.endTimeSelectValues.find(t => t.time == this.endHour);
                    }
                    this.getOvernightEndHours();
                }
                if (this.amenityType == 'range')
                    this.timeRangeSelectValues = res[0].hours;

                this.showTimeSelectSpinner = false;
            },
            error => this.api.errorHandler(error, 'Failed get Bookings for day selected')
        );
    }

    onStartHourChange(event) {
        const startDateForSending = moment(event.value.datetime).format('YYYY-MM-DDTHH:mm');
        const numberOfDays = this.data.day == this.data.endDay ? 0 : 1;
        const endDateForSending = moment(event.value.datetime).add(numberOfDays, 'day').format('YYYY-MM-DDT23:59');
        this.getTimeSelectValues(startDateForSending, endDateForSending, 'endDay');
    }

    getTwentyFourHourTime(timeString) {
        if (!timeString) {
            return '00:00';
        }
        return moment(timeString, 'h:mm A').format('HH:mm');
    }

    includedFieldsExist() {
        return this.amenityFees.some(f => f.include);
    }

    onPayByLinkCheckboxChange(event) {
        if (event.target.checked)
            this.creditCardToken = null;
    }

    // date - format YYYY-MM-DD
    private static generateTimeSelectHours(date: string, interval: number): {
        available: boolean;
        datetime: string; // "2020-10-04T16:30"
        time: string; // "04:30 PM"
    }[] {
        const startDateTime = moment.utc(`${date} 00:00:00`, 'YYYY-MM-DD HH:mm:ss');
        const endDateTime = moment.utc(`${date} 23:30:00`, 'YYYY-MM-DD HH:mm:ss');

        const hours = [AmenitiesModalComponent.momentDateToTimeSelectValue(startDateTime)];
        const lastDate = startDateTime.clone();
        while (Math.abs(endDateTime.diff(lastDate, 'minutes')) >= interval) {
            lastDate.add(interval, 'm');
            hours.push(AmenitiesModalComponent.momentDateToTimeSelectValue(lastDate));
        }
        return hours;
    }

    private static momentDateToTimeSelectValue(momentDate) {
        return {
            available: true,
            datetime: momentDate.format('YYYY-MM-DD') + 'T' + momentDate.format('HH:mm'),
            time: momentDate.format('LT')
        };
    }

    private generateTimeSelectValuesForOverride(res: { date: string; weekday: number }[]) {
        return res.map(r => {
            const selectedWeekDay = this.originalRules.weekDays[r.weekday - 1];
            return selectedWeekDay ? selectedWeekDay.dayHours : [];
        })
        .map((dayRule, index) => {
            return {
                ...res[index],
                hours: AmenitiesModalComponent.generateTimeSelectHours(res[index].date, this.originalRules.timeStep),
                status: 'Available'
            };
        })// god please mercy the one's soul that will encounter this. bless you, fellow warrior
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-modal/amenities-modal.component.ts